export const TaskStatuses = {
  MODERATION: 'task_moderated',
  ACCEPTED: 'task_done',
  DECLINED: 'task_canceled',
}
